module.exports = __webpack_public_path__ + "static/media/tall.0b05d09d.png";